import UserList from '../components/user/UserList';
import { useApp } from '../context/AppContext';
import TaskModal from '../components/task/TaskModal';

export default function UsersPage() {
  const { state, dispatch } = useApp();
  const selectedTask = state.tasks.find(t => t.id === state.selectedTaskId);

  return (
    <>
      <UserList />
      {selectedTask && (
        <TaskModal
          task={selectedTask}
          onClose={() => dispatch({ type: 'SELECT_TASK', payload: null })}
        />
      )}
    </>
  );
}
